module.exports = __webpack_public_path__ + "static/img/service_safeguard_icon_2.b307d447.svg";